// extracted by mini-css-extract-plugin
module.exports = {"displacement-arrow":"_20vzkQc","displacementArrow":"_20vzkQc"};